module.exports = __webpack_public_path__ + "img/MemeETC (8).e0afce6c.jpeg";